module.exports = __webpack_public_path__ + "img/contactMa.08dc93b7.png";